var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cancellation-item" }, [
    _c("div", { staticClass: "cancellation-item-header" }, [
      _vm._v(" " + _vm._s(_vm.item.group) + " ")
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "cancellation-list" },
      _vm._l(_vm.item.items, function(flight) {
        return _c("li", { key: flight.flightKey }, [
          _c("span", { staticClass: "cancellation-flight-number" }, [
            _vm._v("F9 " + _vm._s(flight.flightNumber) + ": ")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "cancellation-flight-cities" }, [
            _vm._v(_vm._s(flight.origin) + "-" + _vm._s(flight.destination))
          ])
        ])
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a1a6692", { render: render, staticRenderFns: staticRenderFns })
  }
}